<template>
  <div class="content">
    <div class="left">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-vertical-demo"
        @select="handleSelect"
      >
        <el-menu-item index="1">
          <span class="left-nav-text">检查主体</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="2">
          <span class="left-nav-text">检查事项和依据</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="3">
          <span class="left-nav-text">检查频次上限</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="4">
          <span class="left-nav-text">检查标准</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="5">
          <span class="left-nav-text">检查计划</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="6">
          <span class="left-nav-text">检查文书</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="right">
      <!-- 检查主体 -->
      <div v-show="activeIndex == 1">
        <div class="list" v-loading="loading_106">
          <ul>
            <li v-for="item in jcztList" @click="tonews(106, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="jczttotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '106')"
            :total="jczttotal"
          >
          </el-pagination>
          <el-empty v-show="jczttotal == 0" description="暂无数据" />
        </div>
      </div>
      <!-- 检查事项和依据 -->
      <div v-show="activeIndex == 2">
        <div class="list" v-loading="loading_107">
          <ul>
            <li v-for="item in jcsxhyjList" @click="tonews(107, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="jcsxhyjtotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '107')"
            :total="jcsxhyjtotal"
          >
          </el-pagination>
          <el-empty v-show="jcsxhyjtotal == 0" description="暂无数据" />
        </div>
      </div>
      <!-- 检查频次上限 -->
      <div v-show="activeIndex == 3">
        <div class="list" v-loading="loading_108">
          <ul>
            <li v-for="item in jcpcsxList" @click="tonews(108, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="jcpcsxtotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '108')"
            :total="jcpcsxtotal"
          >
          </el-pagination>
          <el-empty v-show="jcpcsxtotal == 0" description="暂无数据" />
        </div>
      </div>
      <!-- 检查标准 -->
      <div v-show="activeIndex == 4">
        <div class="list" v-loading="loading_109">
          <ul>
            <li v-for="item in jcbzList" @click="tonews(109, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="jcbztotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '109')"
            :total="jcbztotal"
          >
          </el-pagination>
          <el-empty v-show="jcbztotal == 0" description="暂无数据" />
        </div>
      </div>
      <!-- 检查计划 -->
      <div v-show="activeIndex == 5">
        <div class="list" v-loading="loading_110">
          <ul>
            <li v-for="item in jcjhList" @click="tonews(110, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="jcjhtotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '110')"
            :total="jcjhtotal"
          >
          </el-pagination>
          <el-empty v-show="jcjhtotal == 0" description="暂无数据" />
        </div>
      </div>
      <!-- 检查文书 -->
      <div v-show="activeIndex == 6">
        <div class="list" v-loading="loading_111">
          <ul>
            <li v-for="item in jcwsList" @click="tonews(111, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="jcwstotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '111')"
            :total="jcwstotal"
          >
          </el-pagination>
          <el-empty v-show="jcwstotal == 0" description="暂无数据" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import loan from "./loan.vue"
import qs from "qs"
export default {
  components: {
    loan,
  },
  data() {
    return {
      activeIndex: "1",
      jcztList: [],
      jczttotal: 0,
      loading_106: true,
      jcsxhyjList: [],
      jcsxhyjtotal: 0,
      loading_107: true,
      jcpcsxList: [],
      jcpcsxtotal: 0,
      loading_108: true,
      jcbzList: [],
      jcbztotal: 0,
      loading_109: true,
      jcjhList: [],
      jcjhtotal: 0,
      loading_110: true,
      jcwsList: [],
      jcwstotal: 0,
      loading_111: true,
    }
  },
  filters: {
    //限制文本显示字数,超出部分用...代替
    ellipsis(value, index) {
      if (!value) return ""
      if (value.length > index) {
        return value.slice(0, index) + "..." //0:下标,从第一个字开始显示,50:显示字数,多余用...代替
      }
      return value
    },
    formatTime(value, format = "YYYY-MM-DD") {
      if (!value) return ""
      const date = new Date(value)
      const options = {
        "Y+": date.getFullYear().toString(), // 年
        "M+": (date.getMonth() + 1).toString(), // 月
        "D+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "m+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 可以继续添加其他格式化选项
      }
      for (let k in options) {
        const reg = new RegExp(`(${k})`)
        if (reg.test(format)) {
          format = format.replace(
            reg,
            options[k].length === 1 ? `0${options[k]}` : `${options[k]}`
          )
        }
      }
      return format
    },
  },
  watch: {
    "$route.query.activeIndex": function(newValue, oldValue) {
      this.activeIndex = newValue
    },
  },
  created() {
    if (
      this.$route.query.activeIndex < 15 &&
      this.$route.query.activeIndex > 0
    ) {
      this.activeIndex = this.$route.query.activeIndex
    }
    // 检查主体
    this.getNewList("0", "10", "106")
    // 检查事项和依据
    this.getNewList("0", "10", "107")
    // 检查频次上限
    this.getNewList("0", "10", "108")
    // 检查标准
    this.getNewList("0", "10", "109")
    // 检查计划
    this.getNewList("0", "10", "110")
    // 检查文书
    this.getNewList("0", "10", "111")
  },
  methods: {
    handleSelect(index) {
      if (this.$route.query.activeIndex !== index) {
        this.$router.push({ path: "/sqxzjcgszl?activeIndex=" + index })
      }
    },
    getNewList(first, count, channelIds) {
      let data = {}
      data.first = first
      data.count = count
      data.channelIds = channelIds
      axios
        .post("/api/gateway/03180/09/web/110418", qs.stringify(data))
        .then((response) => {
          switch (channelIds) {
            // 检查主体
            case "106":
              this.loading_106 = false
              this.jcztList = response.data.body
              this.jczttotal = response.data.totalSize
              break
            // 检查事项和依据
            case "107":
              this.jcsxhyjList = response.data.body
              this.jcsxhyjtotal = response.data.totalSize
              this.loading_107 = false
              break
            //检查频次上限
            case "108":
              this.jcpcsxList = response.data.body
              this.jcpcsxtotal = response.data.totalSize
              this.loading_108 = false
              break
            // 检查标准
            case "109":
              this.jcbzList = response.data.body
              this.jcbztotal = response.data.totalSize
              this.loading_109 = false
              break
            // 检查计划
            case "110":
              this.jcjhList = response.data.body
              this.jcjhtotal = response.data.totalSize
              this.loading_110 = false
              break
            // 检查文书
            case "111":
              this.jcwsList = response.data.body
              this.jcwstotal = response.data.totalSize
              this.loading_111 = false
              break
          }
        })
    },
    getList(pagenum, buzType, parentViewItemId) {
      axios
        .post(
          "/token/admin/huaxin/index",
          qs.stringify({
            data: {
              buzType: buzType,
              keyword: "",
              parentViewItemId: parentViewItemId,
              pagenum: pagenum,
              pagerows: "10",
            },
            url: "appapi70009.json",
          })
        )
        .then((response) => {
          switch ((buzType, parentViewItemId)) {
            // 检查主体
            case ("5529", "25"):
              this.jcztList = response.data.result.news.newsList
              this.jczttotal = response.data.result.news.total
              this.loading_106 = false
              break
            // 检查事项和依据
            case ("5529", "26"):
              this.jcsxhyjList = response.data.result.news.newsList
              this.jcsxhyjtotal = response.data.result.news.total
              this.loading_107 = false
              break
            //检查频次上限
            case ("5529", "27"):
              this.jcpcsxList = response.data.result.news.newsList
              this.jcpcsxtotal = response.data.result.news.total
              this.loading_108 = false
              break
            // 检查标准
            case ("5529", "28"):
              this.jcbzList = response.data.result.news.newsList
              this.jcbztotal = response.data.result.news.total
              this.loading_109 = false
              break
            // 检查计划
            case ("5529", "29"):
              this.jcjhList = response.data.result.news.newsList
              this.jcjhtotal = response.data.result.news.total
              this.loading_110 = false
              break
            // 检查文书
            case ("5529", "32"):
              this.jcwsList = response.data.result.news.newsList
              this.jcwstotal = response.data.result.news.total
              this.loading_111 = false
              break
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },

    tonews(channelIds, id) {
      this.$router.push({
        path: "/new_details",
        query: { channelIds: channelIds, id: id },
      })
    },
    handleCurrentChange(buzType, pagenum, parentViewItemId) {
      this.$set(this, "loading_" + buzType + "_" + parentViewItemId, true)
      this.getList(pagenum - 1, buzType, parentViewItemId)
    },
    handleCurrentChange1(first, count, channelIds) {
      this.$set(this, "loading_" + channelIds, true)
      this.getNewList((first - 1) * 10, count, channelIds)
    },
  },
}
</script>

<style scoped>
.content {
  padding-bottom: 20px;
  display: flex;
  background-color: #ffffff;
}
.left {
  width: 250px;
  min-height: 400px;
  background-color: #ffffff;
}
.right {
  width: 930px;
  min-height: 400px;
  margin: 0 20px;
}
.list {
  min-height: 330px;
}
.right .list li {
  height: 32px;
  line-height: 32px;
  text-align: left;
  list-style-type: none;
  border-bottom: 1px dashed #999;
}
.right .list li .text:hover {
  cursor: pointer;
  color: red;
}

.right .time {
  float: right;
  margin-right: 4px;
  font-size: 12px;
  color: #999;
}

.el-menu-vertical-demo span {
  margin-left: 10px;
}
.el-menu-item {
  font-size: 18px;
  margin: 0 10px;
  border-bottom: 1px solid #c8c8c8;
}
.left-nav-icon {
  float: right;
}
.el-pagination {
  text-align: right;
}
.el-divider--horizontal {
  margin: 12px 0;
}
</style>
